<template>
  <o-view :has-white-background="true" :no-scroll="true">
    <o-view :bottom-padding="true">
      <o-nav-bar title="Cambio" :has-back-button="true" />
      <o-message-header
        icon="unlocked-success"
        text="De wagen is nu open"
        :success="true"
      />
      <o-section>
        <p>
          Volg nu de instructies op de boordcomputer om verder te gaan. Je moet
          geen verdere stappen meer doen in deze app.
        </p>
        <o-alert :center="true">
          <p>
            Hieronder staat de pincode die je nodig hebt voor de boordcomputer:
          </p>
          <p class="u-code">4321</p>
        </o-alert>
        <p class="u-small u-muted">
          Iets meer begeleiding nodig bij het openen van je wagen?
          <router-link to="/sales/car/cambio/reservations/locked-instructions">
            Bekijk hier
          </router-link>
          de verschillende stappen of neem contact op met
          <a href="#">de Cambio-helpdesk</a>.
        </p>
      </o-section>
    </o-view>
    <o-pay-button label="Klaar" to="/sales/car/cambio" />
  </o-view>
</template>

<script>
import OMessageHeader from '@/components/OMessageHeader.vue'
import OPayButton from '@/components/OPayButton.vue'
export default {
  name: 'CambioEdit',
  components: {
    OMessageHeader,
    OPayButton
  }
}
</script>
